import { render } from "./langsSkillsForm.vue?vue&type=template&id=b95dba22&scoped=true"
import script from "./langsSkillsForm.vue?vue&type=script&lang=js"
export * from "./langsSkillsForm.vue?vue&type=script&lang=js"

import "./langsSkillsForm.vue?vue&type=style&index=0&id=b95dba22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95dba22"]])

export default __exports__